module.exports = __webpack_public_path__ + "assets/img/WatchBAIOS.3a7d010f.png";